/*
 * Shared header spec for the built-in Billing and Payroll module configs
 * (./modules/billingConfig.js, ./modules/payrollConfig.js). Both render through
 * DetailHeaderCard's `variant: 'finance'` branch, which renders the finance
 * header design inline (avatar / icon chips / engagement badge / state-gated
 * buttons / workflow stepper). Field keys are the stored financeRecords dot-paths.
 *
 * This lives in the parent detailConfig folder (not ./modules) so the module
 * glob in headerConfig.js does not try to register it as a module. `icon` values
 * are string keys resolved by DetailHeaderCard's ICONS map.
 */

// Engagement chip row shared by billing and payroll — BA id, client, employer
// (engagement type as a badge), project, then the payment rule and the period.
//
// The old `paymentCycle` chip is gone. It read a legacy free-text field that
// usually just said "Weekly" — a cadence label that never answered the only
// question this header should: when is this person actually due to be paid.
// In its place are the payment TERM, the DEADLINE it produces, and the BATCH
// the payment run is grouped by.
//
// paymentTermsLabel / paymentDeadlineLabel are stored preformatted on the
// record precisely because chip values resolve against the stored document,
// so a raw date here would render as an ISO timestamp.
// (engagement type as a badge), project, then the payment rule and the period.
//
// The old `paymentCycle` chip is gone. It read a legacy free-text field that
// usually just said "Weekly" — a cadence label that never answered the only
// question this header should: when is this person actually due to be paid.
// In its place are the payment TERM, the DEADLINE it produces, and the BATCH
// the payment run is grouped by.
//
// paymentTermsLabel / paymentDeadlineLabel are stored preformatted on the
// record precisely because chip values resolve against the stored document,
// so a raw date here would render as an ISO timestamp.
export const financeChips = [
  { field: 'baId', label: 'BA', icon: 'idcard' },
  { field: 'clientName', icon: 'bank', tooltip: 'Client' },
  { field: 'employerName', icon: 'team', badgeField: 'engagementType', tooltip: 'Employer' },
  { field: 'projectName', icon: 'project', tooltip: 'Project' },
  // Work priority from the candidate's batchCandidates row — P1 is most urgent.
  // Renders as a dash for anyone with no batchCandidates row, none set, or a
  // timesheet submitted before this existed (MetaChip falls back to '—' rather
  // than hiding an empty chip — same as every other chip in this row).
  { field: 'batchPriority', icon: 'idcard', tooltip: 'Priority' },
  { field: 'paymentTermsLabel', icon: 'cycle', tooltip: 'Payment Terms' },
  { field: 'paymentDeadlineLabel', icon: 'period', tooltip: 'Payment Deadline' },
  { field: 'batchName', icon: 'project', tooltip: 'Payment Batch' },
  // The WORK month (Jun 2026) — distinct from the processing month the payment
  // falls in (Aug 2026 on NET 30), which is shown in the Payment Terms card.
  { field: 'period.label', icon: 'period', tooltip: 'Period' },
];

export default financeChips;
